import { loadTradeupProducts } from '../../components/react/TradeUp/services/loadTradeupProducts';

// Initial state
const initialState = {
  tradeUpProducts: [],
  error: null
};

// Actions
const TRADEUP_PRODUCTS_LOADED = 'tradeUp/TRADEUP_PRODUCTS_LOADED';
const TRADEUP_PRODUCTS_ERROR = 'tradeUp/TRADEUP_PRODUCTS_ERROR';

// Action creators
const tradeUpProductsLoaded = (tradeUpProducts) => ({
  type: TRADEUP_PRODUCTS_LOADED,
  payload: tradeUpProducts
});

const tradeUpProductsError = (error) => ({
  type: TRADEUP_PRODUCTS_ERROR,
  payload: error
});

// Thunks
export const getTradeUpProducts = (mainProductInfo) => async (dispatch) => {
  let tradeUpProducts;
  try {
    tradeUpProducts = await loadTradeupProducts(mainProductInfo);
  } catch (error) {
    return dispatch(tradeUpProductsError(error));
  }
  return dispatch(tradeUpProductsLoaded(tradeUpProducts));
};

// Reducer
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case TRADEUP_PRODUCTS_LOADED: {
      return {
        ...state,
        tradeUpProducts: action.payload,
        error: null
      };
    }
    case TRADEUP_PRODUCTS_ERROR: {
      return {
        ...state,
        tradeUpProducts: [],
        error: action.payload
      };
    }
    default:
      return state;
  }
};
